import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
// errors are nested in data as it currently stands in the API
// this helper extracts all errors present
export var getErrorsFromData = function getErrorsFromData(data) {
  try {
    var error = Object.keys(data).reduce(function (acc, key) {
      return _objectSpread({}, acc, data[key].errors && !!data[key].errors.length && {
        userInputErrors: data[key].errors
      });
    }, {});
    return !!Object.keys(error).length ? error : null;
  } catch (e) {
    return null;
  }
};
export var isDataEmpty = function isDataEmpty(data) {
  return Object.keys(data).reduce(function (_, key) {
    return !!data[key];
  }, true);
};
export function getMappedData(mapFn, data) {
  if (!data) {
    return null;
  }

  var mappedData = mapFn(data);
  var result = mappedData && !!Object.keys(mappedData).length ? mappedData : null;
  return result;
}
export var mergeEdges = function mergeEdges(prevEdges, newEdges) {
  return [].concat(_toConsumableArray(prevEdges), _toConsumableArray(newEdges.filter(function (edge) {
    return !prevEdges.some(function (e) {
      return e.node.id === edge.node.id;
    });
  })));
};
export function filterNotEmptyArrayItems(value) {
  return value !== null && value !== undefined;
}